import React from 'react';
var IconVerified = function IconVerified() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    d: "M-4157.8,11167.161l-.169-.163,0,0-3.45-3.45,1.415-1.413,3.424,3.425,8.264-8.557,1.438,1.39-8.261,8.606.015.016-1.416,1.413Z",
    transform: "translate(4166.172 -11150.375)",
    fill: "#237e17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_867",
    fill: "#fff",
    stroke: "#237e17",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11.15",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4168.172 -11149.375)",
    fill: "#237e17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4158.764,11165.416l-.152-.168,0,0-2.5-2.846,1.025-1.166,2.483,2.826,5.99-7.059,1.042,1.145-5.987,7.1.01.012-1.025,1.166Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4157.876953125 11166.423828125 L -4158.76416015625 11165.416015625 L -4158.91650390625 11165.248046875 L -4158.9140625 11165.244140625 L -4161.41552734375 11162.3984375 L -4160.390625 11161.232421875 L -4157.9072265625 11164.05859375 L -4151.9169921875 11157 L -4150.875 11158.14453125 L -4156.8623046875 11165.24609375 L -4156.85205078125 11165.2578125 L -4157.876953125 11166.423828125 Z",
    stroke: "none",
    fill: "#237e17"
  })));
};
export default IconVerified;